import { BehaviorSubject } from "rxjs";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import CurrencyProviderInterface from "./CurrencyProviderInterface";

class StaticCurrencyProvider implements CurrencyProviderInterface {
    private currentCurrency$: BehaviorSubject<string>;
    constructor(currency: string, private readonly logger: LoggerInterface) {
        this.currentCurrency$ = new BehaviorSubject<string>(currency);
    }
    selectCurrency() {
        return this.currentCurrency$;
    }

    setCurrency(currency: string) {
        this.logger.debug("StaticCurrencyProvider.setCurrency", { currency });
        this.currentCurrency$.next(currency);
    }
}

export default StaticCurrencyProvider;
